<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addAnnouncementPopup">{{ $t('add') }}</vs-button>
      </template>

      <vs-divider></vs-divider>
    </vx-card>

    <vx-card id="announcementDataContainer" :title="$t('announcements')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-dashboard-tab-nav></shared-dashboard-tab-nav>
      </template>

      <shared-announcement-list
        :announcements="announcements"
        :isAction="true"
        :isEdit="true"
        :isSeen="false"
        @customClickEdit="editAnnouncementPopup"
        @customClickView="view"
        @customClickDelete="destroy"
      ></shared-announcement-list>

      <template slot="footer">
        <paginate
          :total="announcementPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadAnnouncements"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

    <modal :title="$t('add_announcement')" id="addAnnouncement" :active.sync="modals.add" size="md">
      <div id="announcementAddFormDataContainer" class="vs-con-loading__container">
        <shared-announcement-add
          @success="onStoreSuccess"
        ></shared-announcement-add>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="addAnnouncementButton" color="primary" type="filled" @click.prevent="storeAnnouncement">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

    <modal :title="$t('edit_announcement')" id="editAnnouncement" :active.sync="modals.edit" size="md">
      <div id="announcementEditFormDataContainer" class="vs-con-loading__container">
        <shared-announcement-edit
          @success="onUpdateSuccess"
        ></shared-announcement-edit>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="updateAnnouncementButton" color="primary" type="filled" @click.prevent="updateAnnouncement">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

    <vs-popup
      :title="$t('view_announcement')"
      :active.sync="modals.view">
      <shared-announcement-view :is-visible="modals.view"></shared-announcement-view>
    </vs-popup>

  </div>
</template>

<script>
import SharedDashboardTabNav from '@/views/Shared/Dashboard/TabNav'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import Announcements from '@/models/Announcements'
import SharedAnnouncementList from '@/views/Shared/Announcement/List'
import SharedAnnouncementAdd from '@/views/Shared/Announcement/Add'
import SharedAnnouncementEdit from '@/views/Shared/Announcement/Edit'
import SharedAnnouncementView from '@/views/Shared/Announcement/View'
import Paginate from '@/mixins/paginate'

export default {
  name: 'User.Dashboard.Announcements',
  mixins: [Paginate],
  components: {
    Modal,
    SharedDashboardTabNav,
    SharedAnnouncementList,
    SharedAnnouncementAdd,
    SharedAnnouncementEdit,
    SharedAnnouncementView
  },
  data () {
    return {
      announcements: {},
      announcementPages: 1,
      itemPerPage: null,
      announcementSearchParams: {
        title: '',
        is_published: ''
      },

      // Modals/Popup
      modals: {
        add: false,
        edit: false,
        view: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initAnnouncementResetFormData')
      }
    },
    'modals.edit' (val) {
      if (!val) {
        EventBus.$emit('initAnnouncementResetFormData')
      }
    }
  },
  mounted () {
    this.loadAnnouncements(this.initialPage, null)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_announcements_table', this.loadAnnouncements)
  },
  methods: {
    async loadAnnouncements (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#announcementDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }

      const response = await Announcements.all({ ...this.announcementSearchParams, page, itemPerPage })
      this.announcements = response.data.data
      this.announcementPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#announcementDataContainer > .con-vs-loading')
    },
    view (id) {
      this.modals.view = true
      EventBus.$emit('initAnnouncementViewData', id)
    },
    editAnnouncementModal (id) {
      this.modals.edit = true
      EventBus.$emit('initAnnouncementGetFormData', id)
    },
    editAnnouncementPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-announcement', {id}, this.editAnnouncementModal)
    },
    updateAnnouncement () {
      EventBus.$emit('initUpdateAnnouncement')
    },
    onUpdateSuccess () {
      this.modals.edit = false
      this.loadAnnouncements()
    },
    addAnnouncementModal () {
      this.modals.add = true
    },
    addAnnouncementPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-announcement', {id}, this.addAnnouncementModal)
    },
    storeAnnouncement () {
      EventBus.$emit('initSaveAnnouncement')
    },
    onStoreSuccess () {
      this.modals.add = false
      this.loadAnnouncements()
    },
    async destroy (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Announcements.destroy({ id })
        this.loadAnnouncements()
      }
    }
  }
}
</script>

<style scoped>

</style>
